module.exports = __webpack_public_path__ + "9e4e027057f647367867a79007fc672e.svg";